import React, { useState } from "react";
import { Table, Button, Space, message, Tooltip } from "antd";
import BookingCalManager from "./BookingCalManager";
import Pnation from "../../../components/Pagination/pagination";
import { LaptopOutlined, DeleteOutlined, CalendarOutlined } from "@ant-design/icons";
import HoverIcon from "../../../components/icons/HoverIcon";
import ModalWithTextInput from "../../../components/modal/ModalWithTextInput";
import { limitWords, toTitleCase } from "../../../utils/utils";
import axiosInstance from "../../../utils/axiosInstance";
const plod = {}

const Meeting = () => {
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [loading, setLoading] = useState({ id: undefined, status: false });
    const [data, setData] = useState([]);
    const [isCancelDemoModalOpen, setIsCancelDemoModalOpen] = useState(false);
    const getData = (data) => {
        setData(data)
    }
    const columns = [
        { title:<Tooltip className="whitespace-nowrap" title="User Name">User Name</Tooltip>, dataIndex: "user_name", key: "user_name" },
        {
            title:<Tooltip className="whitespace-nowrap" title="Email">Email</Tooltip>,
            dataIndex: "user_email",
            key: "user_email",
            render: (email) => (
              <a href={`mailto:${email}`} target="_blank" rel="noopener noreferrer" className="text-blue-500 hover:underline">
                {email}
              </a>
            ),
          },
        { title:<Tooltip className="whitespace-nowrap" title="Requested Date">Requested Date</Tooltip> , dataIndex: "date_time", key: "date_time" },
        { title:<Tooltip className="whitespace-nowrap" title="Company">Company</Tooltip> , dataIndex: "company_name", key: "company_name" },
        { title:<Tooltip className="whitespace-nowrap" title="Status">Status</Tooltip>  , key: "status", render: (_, record) => (toTitleCase(record.status)) },
        { title:  <Tooltip className="whitespace-nowrap" title="Remark">
            <span>Remark</span>
          </Tooltip>, key: "cancel_reason", render: (_, record) => (<Tooltip title={record.cancel_reason}>{limitWords(record.cancel_reason)}</Tooltip>) },
        {
            title: "Action",
            key: "action",
            render: (_, record) => (
                <Space>
                    <HoverIcon
                        icon={<LaptopOutlined   className="!text-[#4E36A3]" />}
                        tooltip="Goto Meet"
                        color={record.status === 'cancelled' ? "gray" : "#4E36A3"}
                        hoverBgColor={record.status === 'cancelled' ? "transparent" : "#4E36A3"}
                        onClick={() => { window.open(record.meet_link) }}
                        hoverColor={record.status === 'cancelled' ? "gray" : "rgb(255, 255, 255)"}
                        disabled={record.status === 'cancelled' || loading.status && loading.id == record.id}
                    // isLoading={}
                    />

                    <HoverIcon
                        icon={<DeleteOutlined   className="!text-red-600" />}
                        tooltip="Cancel Meet"
                        color={loading.status || record.status === 'cancelled' ? "gray" : "Red"}
                        hoverBgColor={loading.status || record.status === 'cancelled' ? "transparent" : "Red"}
                        onClick={() => { setIsCancelDemoModalOpen(true); setLoading({ status: false, id: record.id }) }}
                        hoverColor={loading.status || record.status === 'cancelled' ? "gray" : "rgb(255, 255, 255)"}
                        disabled={loading.status || record.status === 'cancelled'}
                        isLoading={loading.status && loading.id == record.id}
                    />
                </Space>
            ),
        },
    ];

    const handleCancelDemo = async (value) => {
        try {
            setLoading(val => {
                val.status = true;
                return { ...val }
            })
            const payload = {
                meeting_id: loading.id,
                cancel_reason: value.inputField
            }
        const response = await  axiosInstance.post( `/cancel-meeting/`,payload)
            message.success(response.data.message);
            setIsCancelDemoModalOpen(false);
            const tempData = [...data]
            tempData.find((item) => {
                if (item.id == loading.id) {
                    item.cancel_reason = value.inputField;
                    item.status = 'cancelled'
                }
            })
            setData([...tempData])
        } catch (error) {
            console.error(error)
            message.error(error.response.data.error)
        } finally {
            setLoading(val => {
                val.status = false;
                return { ...val }
            })
        }
    };

    const onCloseCalender = () => {
        setIsModalVisible(false)
    }

    const onSetDate =async (payload) => {
        try {

            const response =   await  axiosInstance.post( `/block-slot/`,payload)
            message.success(response.data.message);
            onCloseCalender()
        } catch (error) {
            console.error(error)
            message.error(error.response.data.error)
        }
    }

    return (
        <>
            <Button
                type="primary"
                onClick={() => setIsModalVisible(true)}
                icon={<CalendarOutlined style={{ fontSize: 18 }} />}
            >
                Manage Availability
            </Button>

            <BookingCalManager onCloseCalender={onCloseCalender} isModalVisible={isModalVisible} onSetDate={onSetDate} />
            <div className=" border border-gray-300">
            <Table  pagination={false} columns={columns} dataSource={data} rowKey="id"
              scroll={{ x: "max-content", y: 400 }}
              size="small"
              rowClassName={() => "whitespace-nowrap"}
              className="text-[12px] [&_.ant-table-cell]:p-[1px] [&_.ant-table-cell]:text-[12px] mt-[-20px]"
            />
            </div>
            <Pnation plod={plod} itmeName='Meeting' onPeding={() => { }} onCngPage={getData} url='/meetings/' />
            <ModalWithTextInput isLoadind={loading.status} onSubmit={handleCancelDemo} isOpen={isCancelDemoModalOpen} onCancel={() => { setIsCancelDemoModalOpen(false) }} title='Cancelled Meet' label='Reason' />
        </>
    );
};

export default Meeting;
